module.exports = __webpack_public_path__ + "media/images/icons/cake-6c4b6c12b3dbee33ba75dfe3de6946d2.svg";